/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementCreateMemberAddressResponse } from './MemberManagementCreateMemberAddressResponse';

export type MemberManagementCreateMemberAddressResponseApiRespoonse = {
    data?: MemberManagementCreateMemberAddressResponse;
    status?: MemberManagementCreateMemberAddressResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementCreateMemberAddressResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

